"use client";

import { FC } from "react";
import Link from "next/link";
import { Image } from "react-datocms";
import { useTranslations } from "next-intl";

import { StructuredText } from "components/sections/RichtextSection/StructuredText";

import { IconType } from "@types";

import { Icon } from "components/atoms/Icon/Icon";

import { CBButton } from "components/InlineBlocks/CBButton";
import { BrandedImageTeaserRecord } from "@graphql/types/graphql";
import s from "./BrandedImageTeaser.module.scss";

interface Props {
  data: BrandedImageTeaserRecord;
}

export const BrandedImageTeaser: FC<Props> = ({
  data: { title, descriptionRich, button, email, phoneNumber, chatUrl, image },
}) => {
  const t = useTranslations("common");

  return (
    <div className={s.Wrapper}>
      <div className={s.ContentWrapper}>
        <h3>{title}</h3>
        {descriptionRich && (
          <div className="prose">
            <StructuredText structuredText={descriptionRich as any} />
          </div>
        )}
        {button?.map((buttonItem) => (
          <div key={buttonItem.id}>
            <CBButton {...buttonItem} />
          </div>
        ))}
        <div className={s.HelpWrapper}>
          {(email || phoneNumber || chatUrl) && (
            <p className={s.HelpTitle}>{t("need-help-question")}</p>
          )}
          <div className={s.IconsWrapper}>
            {email && (
              <Link href={`mailto:${email}`} className={s.IconWrapper}>
                <Icon name={IconType.Email} broder rounded size="l" color="blue" />
              </Link>
            )}
            {phoneNumber && (
              <Link href={`tel:${phoneNumber}`} className={s.IconWrapper}>
                <Icon name={IconType.Phone} broder rounded size="l" color="blue" />
              </Link>
            )}
            {chatUrl && (
              <Link href={chatUrl} className={s.IconWrapper}>
                <Icon name={IconType.Message} broder rounded size="l" color="blue" />
              </Link>
            )}
          </div>
        </div>
      </div>
      {image && image.responsiveImage && (
        <div className={s.ImageWrapper}>
          <Image data={image.responsiveImage} />
          <div className={s.LogoWrapper}>
            <Icon name={IconType.PRect} />
          </div>
        </div>
      )}
    </div>
  );
};
